import { render, staticRenderFns } from "./ListaContratacaoFrete.vue?vue&type=template&id=7d34aa46"
import script from "./ListaContratacaoFrete.vue?vue&type=script&lang=js"
export * from "./ListaContratacaoFrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports